import React from "react"
import {FieldInlineEditableProps} from "../../../../render/inline-editable";
import FieldProject from "../project";
import CompaniesCollection from "../../../../../gd-model/tree/companies-collection";
import {SelectParent_RenderType} from "../../../../../gd-ui/select-parent-new/@const";
import SelectParentNew from "../../../../../gd-ui/select-parent-new/select-parent-new";
import ProjectSessionCollection from "../../../../../model2/project/collection";
import ProjectSession from "../../../../../model2/project/project-session";

export default function FieldExpenseProject_InlineEditable(props: FieldInlineEditableProps) {

    const value = props.model[props.field.fieldId]

    const projectId = value ? value : null

    const field: FieldProject = props.field as FieldProject

    const onChange = (projectId: ID) => {
        if (props.onChange) props.onChange(projectId)
    }

    // Filter projects
    let userProjects : any[] = [];
    gd.session.projectUsers.map((pu:any)=>{                         // Old collection !!!!
        if (pu.project && pu.user && pu.user.id === gd.session.me.id) {
            const project = gd.session.projects.get(pu.project.id);
            const expensesEnabled = _.get(project, 'properties.expenses', false);
            if (expensesEnabled) userProjects.push(project)
        }
    })
    userProjects = _.uniqBy(userProjects, (project: ProjectSession) => project.id)
    const availableProjects = new ProjectSessionCollection(userProjects)

    // I dont think we need it anymore
    // // we need it to support archived projects
    // const treeSource = new CompaniesCollection([gd.company])
    // treeSource.resetCompanyProjects(gd.companyId, {
    //     silent              : true,
    //     includeArchived     : true,
    //     includeTemplates    : false
    // });

    return <SelectParentNew className           = {props.className}
                            projectId           = {projectId}
                            parentsFor          = {field.parentsFor}
                            placeholder         = {field.placeholder}
                            availableProjects   = {availableProjects}
                            renderType          = {SelectParent_RenderType.INLINE_EDITABLE}
                            onChange            = {onChange}
    />

}
